// Utilities
import Config from "../constants/Config";
import { qs, cls } from "./util/dom-utils";
import pubsub from "./util/pubsub";

class Borders {
	constructor(el) {

		this.$el = el;
		this.ref = qs('.references');

		this.attachEvents();

	}

	bordersHandler(event) {

		if (event === 'remove') {
			cls.remove(Config.$body, 'is-border-initial')
			cls.add(Config.$body, 'is-border-hidden');
		}
		else {
			cls.remove(Config.$body, 'is-border-hidden')
			cls.add(Config.$body, 'is-border-initial')
		}

	}

	observerScroll() {

		let event = '';

		if ('IntersectionObserver' in window) {

			// Create new IntersectionObserver
			const observer = new IntersectionObserver((entries, observer) => {
				const el = entries[0];

				event = (el.isIntersecting) ? 'remove' : 'enter';

				this.bordersHandler(event);

				pubsub.publish(Config.events.BORDERS_CHANGE, event);
			});

			// Start observing 
			observer.observe(this.ref);

		}

	}

	attachEvents() {

		pubsub.subscribe(Config.events.LOADER_GONE, () => {
			this.observerScroll();
		});

	}

}

export default Borders;

const _init = () => {

	// Elements
	let $el = qs('.borders');

	if ($el) {
		new Borders($el);
	}
};

_init();
